import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Css/SidebarIcons.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FaInfo } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
const SidebarIcons = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    category: "",
    city: "",
    message: "",
  });
  const Showerror = (msg) => {
    toast.error(msg, {
      position: "top-right",
      className: "toast-responsive mx-3",
    });
  };
  //custom sucessfully message handle
  const Showsucess = (msg) => {
    toast.success(msg, {
      position: "top-right",
      className: "toast-responsive mx-3",
    });
  };
  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/contact`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      Showsucess(response?.data?.message);
      setFormData({
        name: "",
        email: "",
        phone: "",
        category: "",
        city: "",
        message: "",
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        Showerror(error.response.data.error);
      } else {
        Showerror("Something went wrong! Please try again.");
      }
    }
  };
  return (
    <>
      <div className="side-icon-bar">
        <Link to="tel:+91-8238235437" aria-label="Call us" className="side-icon-bar-call">
          <FontAwesomeIcon icon={faPhone} className="fs-4" />
        </Link>
        <Link
          id="whatsappLink"
          target="_blank"
          to="https://wa.me/8238235437?text=Hello CareerSahi"
          className="side-icon-bar-whatsapp"
          aria-label="Chat with us on WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="fs-2" color="white" />
        </Link>
        <Link
          id="contactForm"
          aria-label="Open contact form"
          className="side-icon-bar-inquiry"
          onClick={(e) => {
            e.preventDefault();
            setShowForm(true);
          }}
        >
          <FaInfo className="fs-4" />
        </Link>
      </div>

      {showForm && (
        <div className="side-icon-bar-lightbox">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              <b className="fw-semibold" style={{ fontSize: "22px" }}>
                How can we help?
              </b>
              <p style={{ fontSize: "14px" }}>Post your enquiry</p>
            </span>
            <span
              onClick={() => setShowForm(false)}
              className="close-side-icon-bar-lightbox"
            >
              ×
            </span>
          </div>

          <div className="side-icon-bar-lightbox-content">
            <div className="form-container">
              <form onSubmit={handleSubmit}>
                <div className="field-control-group">
                  <input
                    type="text"
                    placeholder="Full Name"
                    autoComplete="off"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field-control-group mt-3">
                  <input
                    type="email"
                    placeholder="Email"
                    className="form-control"
                    autoComplete="off"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field-control-group mt-3">
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    autoComplete="off"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone"
                    required
                  />
                </div>

                <div className="field-control mt-3">
                  <select
                    className="form-select col-12"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      -Select-
                    </option>
                    <option value="Student (8-10 Std)">
                      Student (8-10 Std)
                    </option>
                    <option value="Student (11-12 Std)">
                      Student (11-12 Std)
                    </option>
                    <option value="Student (UG)">Student (UG)</option>
                    <option value="Student (PG)">Student (PG)</option>
                    <option value="Parent (8-10 Std)">Parent (8-10 Std)</option>
                    <option value="Parent (11-12 Std)">
                      Parent (11-12 Std)
                    </option>
                    <option value="Parent (UG)">Parent (UG)</option>
                    <option value="Parent (PG)">Parent (PG)</option>
                    <option
                      style={{ textWrap: "wrap" }}
                      value="Working Professional (1-10 yrs exp)"
                    >
                      Working Professional (1-10 yrs exp)
                    </option>
                    <option value="Senior Working Professional (10+ yrs exp)">
                      Senior Working Professional (10+ yrs exp)
                    </option>
                    <option value="Executive with Career Break">
                      Executive with Career Break
                    </option>
                    <option value="Principal/Teacher">Principal/Teacher</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div className="field-control-group mt-3">
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    maxLength="255"
                    placeholder="City"
                    value={formData.city}
                    autoComplete="off"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="field-control-group mt-3">
                  <textarea
                    className="form-control"
                    placeholder="Anything we need to know? (Optional)"
                    name="message"
                    value={formData.message}
                    autoComplete="off"
                    onChange={handleChange}
                    style={{ height: "100px", margin: "6px 0 12px 0" }}
                  />
                </div>

                <div className="text-center my-3">
                  <button
                    className="rounded-1 custome_button border-0 text-white"
                    style={{
                      minWidth: "148px",
                      minHeight: "37px",
                      background: "var(--primary-color)",
                    }}
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SidebarIcons;
